<template>
  <div class="editPage">
    <qx-card :title="($route.query.id ? '修改' : '新增') + '车辆违章信息'">
      <BaseForm ref="baseForm" />
    </qx-card>
    <SubBtnBox @sub="sub" />
  </div>
</template>

<script>
import BaseForm from './base';
import SubBtnBox from 'components/subBtnBox';
import {
  getViolation,
  doSaveViolationRecord,
} from 'api/car';
import {
  getEnumList,
} from 'api';
import pageDataMixin from '@qx/mixin/pageData';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    BaseForm,
    SubBtnBox,
  },
  data () {
    return {
      pageUrl: '/manage/car/maintain/violation/edit',
      formComponents: [
        'baseForm',
      ],

      // 需要对比的参数
      compareParams: {
        plateNumber: '',
        categoryId: '',
        violationTime: '',
        provinceName: '',
        locationName: '',
        violationAddress: '',
        violationCode: '',
        violationFine: '',
        overdueFine: '',
        violationPoint: '',
        payAmt: '',
        serviceUserId: '',
        violationReason: '',
        personLiable: '',
        recordState: '',
        remark: '',
        picList: [],
      },
    };
  },
  computed: {
    detailParams () {
      return {
        recordId: this.$route.query.id,
      };
    },
  },
  methods: {
    detailApi: getViolation,
    editApi: doSaveViolationRecord,
    // 处理对比参数
    adjustCompareParams (compareParams) {
      if (compareParams.picList.length) {
        compareParams.picFileIds = (compareParams.picList.map((item) => item.fileId)).join(',');
      } else {
        compareParams.picFileIds = '';
      }
    },
  },
  async mounted () {
    const enumsList = await getEnumList({
      codeType: 'VIOLATION_CATEGORY_ID',
    });
    const safeEnum = (index) => (Array.isArray(enumsList) && Array.isArray(enumsList[index])) ? enumsList[index] : [];
    this.$refs.baseForm.setList([{ label: '请选择', value: '-1' }, ...safeEnum(0)]); // 车辆性质
    this.getData();
  },
};
</script>

<style>
</style>
